"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.append = function (target) {
    var elements = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        elements[_i - 1] = arguments[_i];
    }
    var l = elements.length;
    for (var i = 0; i < l; ++i) {
        target.appendChild(elements[i]);
    }
};
exports.appendText = function (target, content) {
    target.insertAdjacentHTML("beforeend", content);
};
